import { ContentBox } from "@msuite/ui/app-shell";
import { OrdersTable } from "@/components/stock/orders-table";

/**
 * The personal order list: what was ordered out of stock for the sites this user is staffed on.
 * The warehouse's own list, across every project, is `sites/data/orders`.
 */
export function Orders() {
	return (
		<ContentBox>
			<OrdersTable
				query={{ scope: "ownProjects" }}
				persistenceKey="my-orders-table"
			/>
		</ContentBox>
	);
}
